import { render, staticRenderFns } from "./navigation-tabs.vue?vue&type=template&id=0c7b6b67&scoped=true"
import script from "./navigation-tabs.vue?vue&type=script&lang=js"
export * from "./navigation-tabs.vue?vue&type=script&lang=js"
import style0 from "./navigation-tabs.vue?vue&type=style&index=0&id=0c7b6b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b6b67",
  null
  
)

export default component.exports